import React, { useEffect, useState } from 'react';
import {
    Avatar,
    Alert,
    Button,
    CssBaseline,
    TextField,
    FormControlLabel,
    Checkbox,
    Link,
    Grid2 as Grid,
    Box,
    Paper,
    Typography,
    Stack,
    Divider,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
// import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
// import LoadingOverlay from '../CommonComponents/LoadingOverlay';
import { useSelector } from 'react-redux';
import { userError } from '../Redux/selectors';
import Animation from './CommonComponents/Animation';
import { Animations } from '../Types/allTypes';
import { useAuth } from '../context/authContext';
import LoadingOverlay from './CommonComponents/LoadingOverlay';

const Login: React.FC = () => {
    const { login, isLoading, isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const userLoginError = useSelector(userError);
    const [showPassword, setShowPassword] = useState(false);
    // const { t } = useTranslation();
    const theme = useTheme();
    const [alertInfo, setAlertInfo] = useState<{
        open: boolean;
        message: string;
        severity: 'success' | 'error' | 'info' | 'warning';
    }>({
        open: false,
        message: "",
        severity: "info"
    });

    const showAlert = (message: string, severity: 'success' | 'error' | 'info' | 'warning') => {
        setAlertInfo({ open: true, message, severity });
        setTimeout(() => {
            handleCloseAlert();
        }, 6000);
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        await validateFormData(data);
    };

    const handleCloseAlert = () => {
        setAlertInfo({ ...alertInfo, open: false });
    };

    const validateFormData = async (data: FormData) => {
        const email = data.get('email') as string;
        const password = data.get('password') as string;

        if (!email || !password) {
            showAlert("AllFieldsRequired", "error");
            return;
        }
        if (!email.includes('@') || !email.includes('.')) {
            showAlert("InvalidEmail", "error");
            return;
        } else {
            const loginResponse = await login(data);
            if (!loginResponse && userLoginError) {
                showAlert(userLoginError, "error");
                return;
            } else {
                navigate('/');
            }
        }
    };

    const handleDummyLogin = async (type: 'Manager' | 'Owner') => {
        let email = '';
        let password = '12345';  
        if (type === 'Manager') {
            email = 'aqua@water.com';
        } else if (type === 'Owner') {
            email = 'john@smith.com'
        }
        const formData = new FormData();
        formData.append('email', email);
        formData.append('password', password);
        const loginResponse = await login(formData);
        if (!loginResponse && userLoginError) {
            showAlert(userLoginError, "error");
            return;
        } else {
            navigate('/dashboard');
        }

    };

    return (
        <>
        <LoadingOverlay isLoading={isLoading}/>
        <Grid container component="main" spacing={1}>
            <CssBaseline />
            <Grid size={{xs: false, sm: 4, md: 7}}
                sx={{
                    backgroundImage: 'url(https://picsum.photos/800/600)',
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: theme.palette.background.default,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    borderRadius: 3,
                }}
            />
            <Grid size={{xs: 12, sm: 8, md: 5}} component={Paper} elevation={6} square sx={{ p: 4, borderRadius: 3}}>
                <Box sx={{ my: 5, mx: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Animation size={{ width: 50, height: 50 }} animationData={Animations.LOCK} />
                    <Typography component="h1" variant="h5">Sign In</Typography>
                    <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
                        {alertInfo.open && (
                            <Box sx={{ paddingBottom: '1rem' }}>
                                <Alert onClose={handleCloseAlert} severity={alertInfo.severity}>
                                    {alertInfo.message}
                                </Alert>
                            </Box>
                        )}
                        <TextField margin="normal" required fullWidth id="email" label={"EmailAddress"} name="email" autoComplete="email" autoFocus />
                        <TextField margin="normal" required fullWidth id="password" label={"Password"} name="password" type={showPassword ? "text" : "password"} autoComplete="current-password" />
                        <FormControlLabel control={<Checkbox onChange={() => setShowPassword(!showPassword)} value="showPassword" />} label={"ShowPassword"} />
                        <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>{"SignIn"}</Button>

                        <Grid container justifyContent={'space-between'}>
                            <Grid>
                                <Link href="/forgotpassword" variant="body2">{"ForgotPassword"}</Link>
                            </Grid>
                            <Grid>
                                <Link href="/signup" variant="body2">{"NoAccountText"}</Link>
                            </Grid>
                        </Grid>
                        <Divider sx={{ mt: 2, mb: 2 }}>{"DUMMY LOGIN FLOW"}</Divider>
                        <Stack direction="row" spacing={1} sx={{ width:'100%', mt: 2, justifyContent: 'space-between' }}>
                            <Button onClick={() => handleDummyLogin('Manager')} sx={{width:'100%'}} variant="contained">Sign In as Manager</Button>
                            <Button onClick={() => handleDummyLogin('Owner')} sx={{width:'100%'}} variant="contained">Sign In as OWNER</Button>
                        </Stack>
                    </Box>
                </Box>
            </Grid>
        </Grid>
        </>
    );
};

export default Login;
